import React from "react";
import SectionReveal from "@/components/SectionReveal";

/**
 * Reusable legal page shell. Accepts an array of sections
 * (title + array of paragraphs) so we can compose real Privacy / Terms copy.
 */
export default function LegalPage({ eyebrow, title, intro, sections = [] }) {
  return (
    <section
      data-testid={`legal-${eyebrow.toLowerCase().replace(/\s+/g, "-")}`}
      className="py-20 lg:py-28 bg-white min-h-[70vh]"
    >
      <div className="mp-container max-w-4xl">
        <SectionReveal>
          <div className="mp-eyebrow-green">{eyebrow}</div>
        </SectionReveal>
        <SectionReveal delay={100}>
          <h1 className="mt-3 font-display text-5xl sm:text-6xl lg:text-7xl uppercase leading-[0.95]">
            {title}
          </h1>
        </SectionReveal>
        {intro && (
          <SectionReveal delay={180}>
            <p className="mt-6 font-body text-black/80 leading-relaxed text-lg">
              {intro}
            </p>
          </SectionReveal>
        )}

        <div className="mt-12 space-y-10">
          {sections.map((s, i) => (
            <SectionReveal key={s.heading} delay={200 + i * 60}>
              <section>
                <h2 className="font-display text-2xl sm:text-3xl uppercase leading-[0.95] text-black">
                  {s.heading}
                </h2>
                <div className="mt-4 space-y-4 font-body text-black/75 leading-relaxed">
                  {s.paragraphs.map((p, j) => (
                    <p key={j}>{p}</p>
                  ))}
                </div>
              </section>
            </SectionReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
